export const Colors = {
  Orange: "#ff9900",
  White: "#ffffff",
  Blue: "#37bbc8",
  Green: "#01d765",
};
